import styled from 'styled-components'

const LabelText = styled.div`
  margin-bottom: 16px;

  @media (max-width: 767px) {
    display: none;
  }
`

export default LabelText